<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body text-center pt-5 pb-5">
                        <h1 class="far fa-smile green-check"></h1>
                        <h3 class="mt-3">{{ $t('eventRegistration.success') }}</h3>
                        <router-link to="/user/registrations" class="btn btn-lg btn-primary">{{$t('button.MyRegistrations')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'EventRegistrationSuccess'
  };
</script>

<style scoped>

</style>
